export const sendPostRequest = async (content, url) => {
  const path = `${process.env.REACT_APP_BACKEND_PATH}/leadlovers`;

  const data = {
    data: content,
    url,
  };

  try {
    await fetch(path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  } catch (error) {
    console.error("Error sending POST request:", error);
  }
};
